import type { IMiscButtons } from "./types";

export const defaultMiscButtons: IMiscButtons["buttons"] = {
    pay: true,
    park: true,
    discount: true,
    print: true,
    scan: true,
    openDrawer: true,
    delete: true,
    parkedReceipts: true,
    closedReceipts: true,
    return: true,
    refund: true,
    tags: true,
    accountBalance: true,
    cmpGiftcardBalance: true,
    splitPayment: true,
    undo: false,
};

export const defaultMiscButtonsSortOrder: IMiscButtons["buttonsSortOrder"] = [
    { label: "pay", showOrder: 0 },
    { label: "park", showOrder: 1 },
    { label: "discount", showOrder: 2 },
    { label: "return", showOrder: 3 },
    { label: "tags", showOrder: 4 },
    { label: "print", showOrder: 5 },
    { label: "scan", showOrder: 6 },
    { label: "openDrawer", showOrder: 7 },
    { label: "delete", showOrder: 8 },
    { label: "refund", showOrder: 9 },
    { label: "parkedReceipts", showOrder: 10 },
    { label: "closedReceipts", showOrder: 11 },
    { label: "accountBalance", showOrder: 12 },
    { label: "cmpGiftcardBalance", showOrder: 13 },
    { label: "splitPayment", showOrder: 14 },
    { label: "undo", showOrder: 15 },
];
